.borderless {
  input,
  button {
    border: none !important;
    &:focus {
      box-shadow: none;
    }
  }
}
